const YOUTUBE_STREAM_URL = 'rtmp://a.rtmp.youtube.com/live2/'

export default YOUTUBE_STREAM_URL
